import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/label-access")({
    beforeLoad: () => {
        throw redirect({ to: "/admin/access/labels", replace: true });
    },
});
